/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPicklistResponse } from './PccPicklistResponse';
import {
    PccPicklistResponseFromJSON,
    PccPicklistResponseFromJSONTyped,
    PccPicklistResponseToJSON,
    PccPicklistResponseToJSONTyped,
} from './PccPicklistResponse';

/**
 * 
 * @export
 * @interface GetPccPicklist200Response
 */
export interface GetPccPicklist200Response {
    /**
     * 
     */
    data?: PccPicklistResponse;
}

/**
 * Check if a given object implements the GetPccPicklist200Response interface.
 */
export function instanceOfGetPccPicklist200Response(value: object): value is GetPccPicklist200Response {
    return true;
}

export function GetPccPicklist200ResponseFromJSON(json: any): GetPccPicklist200Response {
    return GetPccPicklist200ResponseFromJSONTyped(json, false);
}

export function GetPccPicklist200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPccPicklist200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PccPicklistResponseFromJSON(json['data']),
    };
}

export function GetPccPicklist200ResponseToJSON(json: any): GetPccPicklist200Response {
    return GetPccPicklist200ResponseToJSONTyped(json, false);
}

export function GetPccPicklist200ResponseToJSONTyped(value?: GetPccPicklist200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PccPicklistResponseToJSON(value['data']),
    };
}

